
<template>
  <div :class="['raw-link-info', {'raw-link-info--no-released': isNoReleased}]">
    <!-- 网盘释放 -->
    <div class="rd-header">
<!--      <el-tag v-if="isNoReleased" type="warning"  effect="dark" style="width: 80px;line-height: 25px;height: 25px;text-align: center">网盘释放</el-tag>-->
<!--      <span class="rd-lbl">释放方式：</span>-->
      <el-tag   type="success"  effect="dark" style="width: 70px;line-height: 25px;height: 25px">网盘释放</el-tag>
      <span class="rd-count" v-if="selectDetail?.approvalInfos?.length>1" @click="dialogVisible=true">共 {{ selectDetail?.approvalInfos?.length }} 条记录<i v-html="viewDetailIcon()"></i></span>
      <div class="rd-row" style="margin-left: 10px">
        <template v-if="isNoReleased">
          <template v-if="rawLinkInfo.exist">
            <span class="rd-val rd-state--pending"  style="border: 1px solid #ce9743;border-radius: 3px;padding: 0px 3px">未释放</span>
            <!--            <el-tag type="warning" size="small" style="background: white;color: #da7522;border: 1px solid #da7522;padding: 0px 8px;height: 20px;line-height: 20px">未释放</el-tag>-->
          </template>
          <template v-else>
            <span class="rd-val rd-state--pending" style="border: 1px solid #ce9743;border-radius: 3px;padding: 0px 3px">未释放且未上传</span>
          </template>
        </template>
        <template v-else>
          <span class="rd-val rd-warn" v-if="Object.keys(rawLinkInfo)?.length===0||rawLinkInfo?.expired" style="border: 1px solid #f16d6d;border-radius: 3px;padding: 0px 3px">已失效<span v-if="!rawLinkInfo?.expirationTime">且已清空</span></span>
          <span class="rd-val rd-ok" v-else style="border: 1px solid #41a610;border-radius: 3px;padding: 0px 3px">生效中</span>
        </template>
      </div>
    </div>
    <div class="rd-body">

      <div class="rd-row">
        <span class="rd-lbl">释放时间：</span>
        <template v-if="isNoReleased">
          <span class="rd-state--pending">NA</span>
        </template>
        <template v-else>
          <span class="rd-val">{{ Object.keys(rawLinkInfo)?.length>0?(selectDetail.createTime || 'NA'):'NA' }}</span>
        </template>
      </div>
      <div class="rd-row" v-if="rawLinkInfo?.expirationTime">
        <span class="rd-lbl">失效时间：</span>
        <span class="rd-val">{{ rawLinkInfo?.expirationTime || '' }}</span>
      </div>
<!--      <div class="rd-row">-->
<!--        <span class="rd-lbl">状态：</span>-->
<!--        <template v-if="rawLinkInfo.exist||(!isNoReleased&&Object.keys(rawLinkInfo)?.length===0)">-->
<!--          <template v-if="isNoReleased">-->
<!--            <span class="rd-val rd-state&#45;&#45;pending" >未释放</span>-->
<!--&lt;!&ndash;            <el-tag type="warning" size="small" style="background: white;color: #da7522;border: 1px solid #da7522;padding: 0px 8px;height: 20px;line-height: 20px">未释放</el-tag>&ndash;&gt;-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            <span class="rd-val rd-warn" v-if="Object.keys(rawLinkInfo)?.length===0||rawLinkInfo?.expired">已失效<span v-if="!rawLinkInfo?.expirationTime">且已清空</span></span>-->
<!--            <span class="rd-val rd-ok" v-else>生效中</span>-->
<!--          </template>-->

<!--        </template>-->
<!--        <template v-else>-->
<!--          <span class="rd-val rd-warn">未释放且未上传</span>-->
<!--        </template>-->
<!--      </div>-->
      <div class="rd-row" v-if="isNoReleased">
        <span class="rd-lbl">提示：</span>
        <span class="rd-val rd-state--pending">请联系对应销售进行释放</span>
      </div>
      <div class="rd-download rd-row">
<!--        <span class="rd-lbl">操作：</span>-->
        <el-tooltip :content="downloadDisabledTip" :disabled="canDownload" placement="top">
          <span class="rd-download__wrap rd-val">
            <span
                type="button"
                class="rd-download__btn"
                :class="{ 'is-disabled': !canDownload }"
                :disabled="!canDownload"
                @click="handleDownload">
              <i class="el-icon-download"></i>
              <span>点击下载原始数据</span>
            </span>
          </span>
        </el-tooltip>
      </div>

    </div>
    <!-- 释放记录弹框 -->
    <approval-record-dialog
        :show-dialog.sync="dialogVisible"
        title="网盘释放记录"
        :columns="columns"
        :project-id="selectDetail.id||''"
        :table-data="selectDetail.approvalInfos || []">
    </approval-record-dialog>
  </div>
</template>

<script>
import {viewDetailIcon, yunIcon} from "@/utils/iconUtils";
import ApprovalRecordDialog from "@/components/RawDataReleaseInfo/ApprovalRecordDialog.vue";

export default {
  name: "ProjectRawLinkInfo",
  components: {ApprovalRecordDialog},
  data() {
    return {
      yunIcon: yunIcon,
      dialogVisible: false,
      columns: [
        {title: '释放时间', dataIndex: 'operateTime', key: 'operateTime'},
        {title: '样本数', dataIndex: 'sampleNum', key: 'sampleNum', width: 100},
        {title: '样本信息', dataIndex: 'sampleInfo', key: 'sampleInfo', scopedSlots: {customRender: 'sampleInfo'},width: 100},
      ],
    }
  },
  props: {
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rawLinkInfo() {
      return this.selectDetail?.rawInfo?.LINK || {}
    },
    isNoReleased() {
      return this.selectDetail.rawDataStatus === 'NOT_RELEASED'
    },
    // 只有「生效中」才可下载：未释放 / 未上传 / 已失效都置灰
    canDownload() {
      return !this.isNoReleased
          && !!this.rawLinkInfo?.exist
          && Object.keys(this.rawLinkInfo || {}).length > 0
          && !this.rawLinkInfo?.expired
    },
    downloadDisabledTip() {
      if (this.isNoReleased){
        if(!this.rawLinkInfo?.exist){
          return '原始数据未释放且未上传，请联系对应销售'
        }else {
          return '原始数据未释放，暂不可下载，请联系对应销售进行释放'
        }
      } else {
        if(!Object.keys(this.rawLinkInfo || {}).length || this.rawLinkInfo?.expired){
          return '原始数据已过期，不可下载'
        }
      }
    }
  },
  methods: {
    viewDetailIcon() {
      return viewDetailIcon
    },
    lookSampleInfo() {
      this.$emit('lookSampleInfo', this.selectDetail)
    },
    // 直接向外传递，由祖组件调用它自己的下载原始数据逻辑
    handleDownload() {
      if (!this.canDownload) return
      this.$emit('downloadRawData', this.selectDetail)
    },
  },

}
</script>

<style scoped>
.raw-link-info {
  font-size: 13px;
  color: #303133;
}
/* 头部：彩色标题 + 底部浅色分隔线 */
.rd-header {
  display: flex;
  //justify-content: space-between;
  align-items: center;
  //gap: 10px;
  margin-bottom: 3px;
  padding-bottom: 3px;
}
.rd-count {
  font-size: 12px;
  color: #3a9c3a;
  cursor: pointer;
  transition: opacity .15s;
}
.rd-count:hover {
  opacity: .7;
  text-decoration: underline;
}
/* 左边线极简：标签两端对齐等宽 + 值加粗，宽松行距 */
.rd-body {
  line-height: 1.3;
}
.rd-row {
  display: flex;
  align-items: baseline;
  padding: 1px 0;
}
.rd-lbl {
  width: 5em;
  text-align: justify;
  text-align-last: justify;
  color: #3a9c3a;
  white-space: nowrap;
  flex-shrink: 0;
}
.rd-val {
  color: #3a9c3a;
  font-weight: 500;
  word-break: break-all;
}
.raw-link-info--no-released .rd-lbl,
.raw-link-info--no-released .rd-val {
  color: #c77c14;
}
.rd-ok {
  color: #3a9c3a;
}
.rd-state--pending{
  color: #c77c14;
}
.rd-warn {
  color: #f14545 !important;
}

/* 下载原始数据 */
.rd-download {
  //margin-top: 8px;
  //margin-left: 13px;
}
.rd-download__wrap {
  display: inline-flex;
}
.rd-download__btn {
  display: inline-flex;
  align-items: center;
  gap: 0px;
  margin-top: 2px;
  height: 22px;
  padding: 0 5px;
  //border: 1px solid #3f9dfe;
  //border: 1px solid #bdd5fc;
  //border: 1px solid #5daf34;
  border-radius:5px;
  font-size: 13px;
  //font-weight: 600;
  //letter-spacing: .5px;
  color: #3f9dfe;
  //background-color: rgba(223, 235, 255, 0.59);
  //color: #5cae35;
  cursor: pointer;
  //background: #ffffff;
  //background: linear-gradient(135deg, #4bb35c 0%, #2f9a5e 100%);
  //background: #ebf5e6;
  //background: linear-gradient(135deg, #58e870 0%, #2f9a5e 100%);
  //box-shadow: 0 4px 10px rgba(47, 154, 94, .28);
  //transition: transform .2s, box-shadow .2s;
}
.rd-download__btn i {
  font-size: 14px;
}
.rd-download__btn:not(.is-disabled):hover {
background: #3f9dfe;

  color: white;
}
/* 未释放 / 已失效 / 未上传：置灰不可点 */
.rd-download__btn.is-disabled {

  cursor: not-allowed;
  color: #a9a9ab;
  //background: rgba(228, 228, 234, 0.33);
  //background: rgba(248, 247, 247, 0.93);

  //border: 1px solid #dfdfe0;
  box-shadow: none;
}
</style>
